import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { DialogData } from '../purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { CommonModule, Location } from '@angular/common';
import { StoresService } from 'src/app/home/services/stores.service';
import { ImplantsEditComponent } from '../implants-edit/implants-edit.component';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-implants-modal',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CommonModule,
    RouterLink
  ],
  templateUrl: './implants-modal.component.html',
  styleUrls: ['./implants-modal.component.scss', '../../app.component.scss']
})
export class ImplantsModalComponent implements OnInit{
  @ViewChild('timelineWrapper', { static: true }) timelineWrapper: ElementRef;

  ngAfterViewInit() {
    const timelines = this.timelineWrapper.nativeElement.querySelectorAll('.timeline');
        
    timelines.forEach(timeline => {
      const dot: any = timeline.querySelector('.timeline-dot');
      const content: any = timeline.querySelector('.timeline-content');
      const contentHeight = content.offsetHeight;
      const dotTop = contentHeight / 2;
      const dotsTop = contentHeight * 1.075;
      dot.style.top = `${dotTop}px`;
    
      const line: any = timeline.querySelector('.timeline-line');
      
      if (line) {
        line.style.height = `${dotsTop}px`;
      }
    });
  }
  public dialogData: any;

  public implantDetails: any;


  public implantDetailsProps: any = {
    storeName: {
      title: "Store",
      value: "-- --"
    },
    batchNumber: {
      title: "Batch Number",
      value: "-- --"
    },
    expiryDate: {
      title: "Expiry Date",
      value: "-- --"
    },
    productCode: {
      title: "Product Code",
      value: "-- --"
    },
    rfid: {
      title: "RFID",
      value: "-- --"
    },
    productCategory:{
      title: "Product Category",
      value: "-- --"
    },
    cabinet:{
      id: "",
      title: "cabinet",
      value: "-- --"
    },
    deviceId:{
      title: "Device Id",
      value: "-- --"
    },
    bodyType:{
      title: "Body Type",
      value: "-- --"
    },
    implantType:{
      title: "Implant Type",
      value: "-- --"
    },
    rate:{
      symbol: "euro",
      title: "Rate",
      value: "-- --"
    },
  };

  constructor(
    public storeService: StoresService,
    public dialogRef: MatDialogRef<ImplantsModalComponent>,
    public dialog: MatDialog,
    public location: Location,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getImplantDetails();
  }

  getImplantDetails(){
    this.storeService.getImplantDetails(this.dialogData.storeId, this.dialogData.implantId).subscribe((res)=>{
      if (res.data) {
        this.implantDetails = res.data;
      }
    });
  }

  openEditDialog(storeId: string, implantId: string): void {
    const dialogRef = this.dialog.open(ImplantsEditComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }


  onClose(): void {
    this.dialogRef.close();
  }

  redirectToCabinet(cabinetId){
    this.router.navigateByUrl('/home/stocks/cabinets/'+ cabinetId);
    this.dialogRef.close();
  }

}
